<div class="dialog-foto-perfil">
  <h2>Imagem de perfil</h2>

  <div *ngIf="carregando" class="carregando"><mat-spinner diameter="36"></mat-spinner></div>

  <ng-container *ngIf="!carregando">
    <div class="editor" *ngIf="imagemOriginal; else escolhaImagem">
      <div class="imagem-editor">
        <div class="preview" (pointerdown)="iniciarArraste($event)" (pointermove)="arrastar($event)"
          (pointerup)="encerrarArraste()" (pointercancel)="encerrarArraste()">
          <img [src]="preview" alt="Prévia da foto de perfil" draggable="false"
            [style.width.%]="larguraPreview()" [style.height.%]="alturaPreview()"
            [style.left.%]="deslocamentoPreviewX()" [style.top.%]="deslocamentoPreviewY()">
        </div>
        <input class="zoom" type="range" min="1" max="4" step="0.05" [(ngModel)]="zoom" aria-label="Zoom da imagem">
      </div>
      <div class="controles">
        <p>Arraste a imagem para definir o enquadramento.</p>
        <button mat-stroked-button type="button" (click)="fileInput.click()">Escolher outra imagem</button>
      </div>
    </div>

    <ng-template #escolhaImagem>
      <button class="foto-atual" *ngIf="imagemAtual" type="button" (click)="fileInput.click()">
        <img [src]="imagemAtual" alt="Foto de perfil atual">
        <span>Alterar imagem de perfil</span>
      </button>
      <div class="area-upload" (dragover)="$event.preventDefault()" (drop)="onDrop($event)" (click)="fileInput.click()">
        <mat-icon>add_a_photo</mat-icon>
        <span>{{ imagemAtual ? 'Escolha outra imagem ou arraste-a aqui' : 'Escolha uma imagem ou arraste-a aqui' }}</span>
      </div>
    </ng-template>

    <input #fileInput type="file" accept="image/*" hidden (change)="selecionarArquivo($event)">
    <div class="acoes">
      <button mat-button type="button" (click)="cancelar()" [disabled]="salvando">Cancelar</button>
      <button mat-button color="warn" type="button" *ngIf="imagemAtual" (click)="remover()" [disabled]="salvando">Remover foto</button>
      <button mat-raised-button color="primary" type="button" *ngIf="imagemOriginal" (click)="salvar()" [disabled]="salvando">Salvar foto</button>
    </div>
  </ng-container>
</div>
